import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Refund } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminRefundsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/refunds`;

  constructor(private http: HttpClient) {}

  getRefunds(): Observable<PaginatedResponse<Refund>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  updateRefundStatus(id: number, status: string): Observable<Refund> {
    return this.http.put<ApiResponse<Refund>>(`${this.baseUrl}/${id}/status`, { status }).pipe(
      map(res => res.data)
    );
  }
}
